<template lang="html">
  <nav>
    <router-link 
      to="/" 
      class="logo near-black">
      <Keys />
    </router-link>

    <router-link 
      to="/cart" 
      class="near-black relative">
      <Cart class="black cart relative" />
      <transition 
        name="plop" 
        mode="in-out">
        <div 
          v-if="cartQuantity > 0" 
          :key="cartQuantity" 
          mode="in-out" 
          class="cart-count flex justify-center items-center bg-yellow h-6 w-6 rounded-full text-sm">
          {{ cartQuantity }}
        </div>
      </transition>
    </router-link>
  </nav>
</template>

<script>
import Keys from '@/components/svgs/Keys'
import Cart from '@/components/svgs/Cart'
import { mapGetters } from 'vuex'

export default {
  components: {
    Keys,
    Cart,
  },
  computed: {
    ...mapGetters(['cartQuantity']),
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/partials/colors.scss';

nav {
  align-items: center;
  border-bottom: 1px solid $gray;
  display: flex;
  overflow: hidden;
  padding: 1rem;
  .logo {
    height: 3rem;
    width: 3rem;
    margin-right: auto;
    padding: 0;
  }

  .cart {
    margin-left: 2rem;
    z-index: 10;
  }
  .cart-count {
    position: absolute;
    right: 7px;
    top: -12px;
    transition: all 0.2s cubic-bezier(0.8, 0.22, 0.99, 1.59);
    z-index: 0;
  }

  .plop-enter {
    top: -50px;
  }
  .plop-leave-to {
    opacity: 0;
  }

  a {
    display: inline-block;
    padding: 0.25rem 0.5rem;
    text-decoration: none;
    color: #999;
    transition: color 0.3s ease;
  }

  a:hover,
  a.active {
    color: $darkBlue;
  }
}
</style>
